<script setup lang="ts">
import { convertDateFieldDateToUTCDate, formatDateFieldDate } from '@/utils/date';
import { isValid } from 'date-fns';
import { computed, onMounted, ref, watch } from 'vue';
import { VTextField } from 'vuetify/components';

type VTextFieldProps = InstanceType<typeof VTextField>['$props'];

interface IVDateFieldProps extends /* @vue-ignore */ VTextFieldProps {
    label: string;
    includeTime?: boolean;
    min?: string;
    max?: string;
    rules: ((value: any) => string | boolean)[];
    required?: boolean;
    disabled?: boolean;
}

const props = withDefaults(defineProps<IVDateFieldProps>(), { includeTime: false });
const emit = defineEmits(['update:modelValue']);

const dateModel = defineModel<Date>();

const date = ref<string>();
const time = ref<string>();

onMounted(populateFields);
watch(dateModel, populateFields);

watch(date, updateDate);
watch(time, updateDate);

const timeFieldProps = computed(() => {
    const { min: _min, max: _max, rules: _rules, ...rest } = props;
    return { ...rest };
});

function populateFields() {
    if (isValid(dateModel.value)) {
        date.value = formatDateFieldDate(dateModel.value, true);
        time.value = formatDateFieldDate(dateModel.value, false);
    }
}

function updateDate() {
    if (!date.value) {
        emit('update:modelValue', null);
        return;
    }

    const dateString = time.value ? `${date.value}T${time.value}` : `${date.value}`;
    const newDate = convertDateFieldDateToUTCDate(dateString, time.value != null);

    dateModel.value = newDate;
    emit('update:modelValue', newDate);
}
</script>

<template>
    <div class="d-flex justify-center ga-5">
        <v-text-field
            v-bind="props"
            :label="includeTime ? `${props.label} datum` : props.label"
            v-model="date"
            type="date"
            :clearable="!required"
            @click:clear="time = undefined"
        />
        <v-text-field
            v-if="includeTime"
            v-bind="timeFieldProps"
            :label="includeTime ? `${props.label} tijd` : props.label"
            v-model="time"
            type="time"
        />
    </div>
</template>
